/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { createNamespacedWetagHooksForOrg, createWetagHooksForPropDriven } from '@frontend/wetags';
import type { AiReceptionistTags } from './tags';

const AI_RECEPTIONIST_NAMESPACE = 'ai-receptionist';

export const AiReceptionistOrg = createNamespacedWetagHooksForOrg<AiReceptionistTags>(AI_RECEPTIONIST_NAMESPACE);

export const AiReceptionistProp = createWetagHooksForPropDriven<AiReceptionistTags>(AI_RECEPTIONIST_NAMESPACE);
